import { Controller } from '@hotwired/stimulus'

// Selector de la portada de cuentas (ENH-RNK-7023): el título, las pestañas, cada tarjeta de la
// pestaña abierta y el botón al comparador suben y aparecen al tener el 20 % a la vista. Solo la
// primera vez: al cambiar de pestaña no se repite. Espera a las fuentes y un poco más, para que
// nada se dé por visto antes de colocarse. `data-aparece` se quita al acabar, para no pisar las
// transiciones propias de cada pieza. Sin IntersectionObserver o con «reducir movimiento», las
// piezas se ven siempre.
export default class extends Controller {
  static targets = ['pieza']

  connect () {
    const sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (sinMovimiento || !window.IntersectionObserver) return

    const tarjetas = this.element.querySelectorAll('[role=tabpanel]:not([hidden]) .rnk-ProductComparerCard')
    this.piezas = [...this.piezaTargets, ...tarjetas]
    this.piezas.forEach((pieza) => { pieza.dataset.aparece = 'espera' })
    this.temporizadores = []
    this.observador = new IntersectionObserver((entradas) => {
      entradas.filter((entrada) => entrada.isIntersecting).forEach(({ target }) => {
        this.observador.unobserve(target)
        target.dataset.aparece = 'ya'
        this.temporizadores.push(setTimeout(() => delete target.dataset.aparece, 1500))
      })
    }, { threshold: 0.2 })
    const fuentes = document.fonts?.ready || Promise.resolve()
    fuentes.then(() => {
      this.temporizadores.push(setTimeout(() => this.piezas.forEach((pieza) => this.observador?.observe(pieza)), 300))
    })
  }

  disconnect () {
    this.observador?.disconnect()
    this.observador = null
    this.temporizadores?.forEach(clearTimeout)
    this.piezas?.forEach((pieza) => delete pieza.dataset.aparece)
  }
}
